import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IButton } from './button.interface';

@Component({
    selector: 'mlp-ng-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonSharedComponent {
    @Input() button: IButton;
    @Input() disabled = false;
    @Input() btnSize: 'large' | 'medium' | 'xsmall' | 'small' = 'medium';
    @Input() btnStyle: 'secondary' | 'tertiary';
    @Input() btnShadow = false;
    @Input() btnType: 'submit' | 'button' | 'reset' = 'button';
    @Input() fullWidth = false;
    @Input() label: string;
    @Input() labelSecondary: string;
    @Input() loading = false;

    get type(): string { return (this.button && this.button.type) ? this.button.type : 'button'; }
}
